import { useEffect } from 'react';

import { useSale } from '../../../../hooks/sale/useSale';

import { useAuthUser } from '../../../../hooks/auth/useAuthUser';

import { useSystemOperationMode } from '../../../../hooks/settings/useSystemOperationMode';

import POSActionButton from '../credit-note/shared/POSActionButton';

const POSFinalizeButton = () => {
  // =====================================================
  // 🔹 Hooks
  // =====================================================

  const {
    form,

    handlerFinalizeSale,

    handlerSaveSale,

    handlerSendToCashier,

    isCashierProcessingMode,
  } = useSale();

  const {
    form: operationConfig,

    fetchActiveConfiguration,
  } = useSystemOperationMode();

  const { hasRole } = useAuthUser();

  // =====================================================
  // 🔹 Effects
  // =====================================================

  useEffect(() => {
    fetchActiveConfiguration();
  }, []);

  // =====================================================
  // 🔹 States
  // =====================================================

  const products = form?.products || [];

  const hasProducts =
    products.length > 0;

  const isSupport =
    hasRole('SUPPORT');

  // =====================================================
  // 🔹 Operation Mode
  // =====================================================

  const isPendingCashierMode =
    operationConfig.saleOperationMode ===
    'PENDING_CASHIER';

  /**
   * 🔥 Cuando el cajero
   * procesa la venta,
   * ya NO debe enviarse
   * nuevamente a caja.
   */
  const shouldSendToCashier =
    isPendingCashierMode &&
    !isCashierProcessingMode;

  // =====================================================
  // 🎨 Render
  // =====================================================

  return (
    <div className="flex flex-col gap-3">
      {/* ===================================================== */}
      {/* 🔹 Save */}
      {/* ===================================================== */}

      {isSupport &&
        !isCashierProcessingMode && (
          <POSActionButton
            variant="secondary"
            fullWidth
            disabled={!hasProducts}
            onClick={() =>
              handlerSaveSale(form)
            }
          >
            Guardar Cambios
          </POSActionButton>
        )}

      {/* ===================================================== */}
      {/* 🔹 Send To Cashier */}
      {/* ===================================================== */}

      {shouldSendToCashier ? (
        <POSActionButton
          variant="success"
          fullWidth
          disabled={!hasProducts}
          onClick={() =>
            handlerSendToCashier(form.id)
          }
        >
          Enviar a Caja
        </POSActionButton>
      ) : (
        /* ===================================================== */
        /* 🔹 Finalize */
        /* ===================================================== */

        <POSActionButton
          variant="primary"
          fullWidth
          disabled={!hasProducts}
          onClick={() =>
            handlerFinalizeSale(form)
          }
        >
          Finalizar Venta
        </POSActionButton>
      )}
    </div>
  );
};

export default POSFinalizeButton;